<ng-template #cpuInput>
  <mat-form-field>
    <mat-label>{{formData.label}}</mat-label>
    <textarea matInput
              [formControl]="formGroup.controls[formName]"
              [required]="formData.isRequired"></textarea>
    <app-error [formName]="formName" [formGroup]="formGroup"></app-error>
  </mat-form-field>
</ng-template>

<app-base [componentsTemplate]="cpuInput" [childContext]="ctx"></app-base>


